<app-dialog-header
  [header]="'label.action.manage_labels.header' | translate"
  iconClass="icon-label-icon"
>
</app-dialog-header>
<app-dialog-content [formGroup]="form">
  <div
    [spinner]="loading"
    class="p-grid p-dir-col"
  >
    <div class="p-col">
      <app-pick-list
        [options]="options"
        formControlName="labels"
        valueKey="id"
      >
        <ng-template
          let-item
          appTemplate="item"
        >
          <lib-label-display-item [label]="item"></lib-label-display-item>
        </ng-template>
      </app-pick-list>
    </div>
  </div>
</app-dialog-content>
<div class="dialog-footer align-right">
  <button
    (click)="close()"
    type="button"
    class="proget-button text-only"
  >
    {{ 'button.close.label' | translate }}
  </button>
  <button
    [disabled]="loading"
    (click)="submit()"
    type="button"
    class="proget-button text-only primary-button"
  >
    {{ 'button.submit.label' | translate }}
  </button>
</div>
